import Text, { TextProps } from "@/components/Text";
import styled, { DefaultTheme, StyledComponent, css } from "styled-components";

export const Input = styled.input<{ $hasError?: boolean; $small?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 16px;
  height: 46px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  outline: none !important;
  transition: 0.2s ease-out border-color;
  font-family: ${({ theme }) => theme.typography.captionSemibold.fontFamily};
  font-size: ${({ theme }) => theme.typography.captionSemibold.fontSize};
  font-weight: ${({ theme }) => theme.typography.captionSemibold.fontWeight};

  &:focus,
  &:hover {
    border-color: ${({ theme }) => theme.colors.gray};
  }
  &::placeholder {
    color: ${({ theme }) => theme.colors.gray};
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.grayscaleLight};
    cursor: not-allowed;
    &:focus,
    &:hover {
      border-color: ${({ theme }) => theme.colors.grayscale};
    }
  }

  ${({ theme, $hasError }) =>
    $hasError &&
    css`
      border-color: ${theme.colors.error};
    `}
  ${({ theme, $small }) =>
    $small &&
    css`
      font-family: ${theme.typography.smallHeadline.fontFamily};
      font-size: ${theme.typography.smallHeadline.fontSize};
      height: 32px;
    `}
`;

export const FormLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 24px;
  grid-column-gap: 24px;
`;

export const Larger = styled.div`
  grid-column: span 2;
`;

export const Textarea = styled(Input).attrs({ as: "textarea" })`
  display: block;
  padding: 12px 16px;
  height: 138px;
` as StyledComponent<
  "textarea",
  DefaultTheme,
  TextProps & {
    as: string;
    $hasError?: boolean;
  },
  "$type" | "as"
>;

export const Label = styled(Text).attrs({ as: "label", $type: "smallBold" })`
  margin: 0 0 8px;
  display: block;
  text-align: left;
` as StyledComponent<
  "label",
  DefaultTheme,
  TextProps & {
    as: string;
    $type: string;
  },
  "$type" | "as"
>;

export const Radios = styled.div`
  display: flex;
  margin-top: 18px;
  gap: 32px;
`;

export const RadiosLabel = styled(Label)`
  position: relative;
  cursor: pointer;
  user-select: none;
  margin: 0;
  padding-left: 25px;
`;

export const RadioCircle = styled.span`
  width: 16px;
  height: 16px;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto 0;
  position: absolute;
  border: 2px solid ${({ theme }) => theme.colors.gray};
  border-radius: 1px;
  transition: 0.2s ease-out all;
  border-radius: 50%;
  transition: border-color ease-out 0.2s;
  &:after {
    content: "";
    position: absolute;
    opacity: 0;
    width: 8px;
    height: 8px;
    background: ${({ theme }) => theme.colors.purple};
    border-radius: 50%;
    left: 2px;
    top: 2px;
    transition: opacity ease-out 0.2s;
  }
`;

export const RadioInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 1px;
  width: 1px;
  border-radius: 50%;
  &:checked ~ ${RadioCircle} {
    border-color: ${({ theme }) => theme.colors.purple};
    &::after {
      opacity: 1;
    }
  }
  &:disabled ~ ${RadioCircle} {
    border-color: ${({ theme }) => theme.colors.gray};
    cursor: not-allowed;
    &::after {
      background: ${({ theme }) => theme.colors.gray};
    }
  }
`;
